<template>
	<v-col class="ma-0 pa-0" cols="12" id="header">
		<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
			<v-row class="ma-0 pa-0" align="center" id="header_body">
				<v-col class="ma-0 pa-0" cols="auto" style="font-weight:bold;font-size:1rem;">
					{{ this.$i18n.locale == 'jp' ? formatDateLang(today, 'jp') : (this.$i18n.locale == 'en' ? formatDateLang(today, 'en') : formatDateLang(today, 'ko')) }}
				</v-col>
			</v-row>
		</v-col>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		today: new Date(),
	}),
	created() {
		// console.log(this.today);
		// console.log(this.$i18n.locale);
	},
	methods: {
		
	}
}
</script>

<style lang="scss" scoped>
#header {
	background-color: #272A33;
	position: sticky;
	top: 0;
	z-index: 5;
}
#header_body {
	height: 50px;
}
</style>